import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("frases.productize_mi_usecase"))),
      ]),
      _c(VBreadcrumbs, { staticClass: "pa-0 py-2 text--black" }, [
        _vm._v(
          " " + _vm._s(_vm.$t("attributes.sandbox.productize_model_desc")) + " "
        ),
      ]),
      _c(VRow, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c(
              VCard,
              [
                _c(VCardSubtitle),
                _c(
                  VContainer,
                  { staticClass: "justify-center", attrs: { fluid: "" } },
                  [
                    _c(
                      VRow,
                      { attrs: { justify: "center" } },
                      [
                        _c(
                          VCol,
                          {
                            staticClass: "col-md-10 col-xl-8 col-12",
                            attrs: { cols: "12" },
                          },
                          [
                            _c("grid-card-component", {
                              attrs: { "custom-cards": _vm.cards },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }